import React from 'react';

import { Alert, Flex, List, Spin, Tag, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IComputerCheck } from '@app/services/cades/interfaces';

interface IProps {
  result?: IComputerCheck;
  running: boolean;
  withDiagnosticLink?: boolean;
}

export const CadesChecks: React.FC<IProps> = ({ result, running, withDiagnosticLink = false }) => {
  const cadesT = useTranslation(NSKeys.cades);
  if (running) {
    return (
      <Flex justify="center" style={{ padding: 24 }}>
        <Spin />
      </Flex>
    );
  }
  return (
    <Flex vertical gap={12}>
      <List
        dataSource={result?.checks}
        renderItem={(item) => (
          <List.Item>
            <Flex vertical gap={8} style={{ width: '100%' }}>
              <Flex justify="space-between" gap={12}>
                <Typography.Text>{cadesT.t(`checks.${item.key}` as const)}</Typography.Text>
                <Tag color={item.status === 'success' ? 'success' : item.status === 'error' ? 'error' : 'default'}>
                  {cadesT.t(`checkStatus.${item.status}` as const)}
                </Tag>
              </Flex>
              {item.value && <Typography.Text>{item.value}</Typography.Text>}
              {(item.status === 'error' || item.status === 'unavailable') && (
                <Alert
                  type={item.status === 'error' ? 'error' : 'warning'}
                  showIcon
                  title={item.hint && cadesT.t(`hints.${item.hint}` as const)}
                  description={item.error}
                />
              )}
            </Flex>
          </List.Item>
        )}
      />
      {result && !result.ready && (
        <Flex gap={16} wrap>
          <Typography.Link href="https://cryptopro.ru/products/cades/plugin" target="_blank" rel="noopener noreferrer">
            {cadesT.t('installPlugin')}
          </Typography.Link>
          <Typography.Link
            href="https://docs.cryptopro.ru/cades/plugin/plugin-installation"
            target="_blank"
            rel="noopener noreferrer"
          >
            {cadesT.t('installExtension')}
          </Typography.Link>
          <Typography.Link href="https://cryptopro.ru/products/csp" target="_blank" rel="noopener noreferrer">
            {cadesT.t('installCsp')}
          </Typography.Link>
        </Flex>
      )}
      {withDiagnosticLink && (
        <Typography.Link href="/cryptopro" target="_blank" rel="noopener noreferrer">
          {cadesT.t('title')}
        </Typography.Link>
      )}
    </Flex>
  );
};
